import styled from '@emotion/styled/macro';
import { css } from '@emotion/react';
import { isMobile } from 'helpers';
import Box from '@mui/material/Box';

const defaultPadding = isMobile ? '1.5rem 1rem' : '1.5rem';

const PaperContent = styled(Box)`

  padding: ${({ disablePadding }) => disablePadding ? '0' : defaultPadding};

  @media(max-width: 320px) {
    padding: ${({ disablePadding }) => disablePadding ? '0' : '1.5rem 0.5rem'};
  }

  ${({ scrollable }) => {
    if (!scrollable) {
      return '';
    }

    return css`
      overflow-y: scroll;
      min-height: 500px;
      max-height: calc(100vh - 500px);
    `;
  }}
`;

export default PaperContent;
